import { PortalTelemetryScreen } from '../../../app/telemetry/portalTelemetryScreens';
import { portalAction, portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material"

interface Props {
    showDialog: boolean;
    title: string;
    content: React.ReactNode;
    showYesNoButtons?: boolean;
    showRedirectToPcsEventDashboard?: boolean;
    skipButtonClick?: () => void;
    yesButtonClick?: () => void;
    noButtonClick?: () => void;
    redirectToPcsEventDashboardClick?: () => void;
}

export default function PcsEventDialog(props: Props) {
    const { showDialog, title, content, skipButtonClick, yesButtonClick, noButtonClick, redirectToPcsEventDashboardClick } = props;

    return <Dialog
        open={showDialog}
        onClose={skipButtonClick}
        aria-labelledby="pcs-event-changes-dialog"
        aria-describedby="pcs-event-changes-dialog"
    >
        <DialogTitle id="pcs-event-changes-dialog">
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="pcs-event-changes-dialog">
                {content}
            </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
            {props.showYesNoButtons === true &&
                <>
                    <Button variant="contained" color="primary"
                        onClick={portalAction(portalScreenContext(PortalTelemetryScreen.PcsEventDialog), `${PortalTelemetryScreen.PcsEventDialog}.onClick.yesButtonClick`, yesButtonClick)} autoFocus>
                        Yes
                    </Button>
                    <Button onClick={portalAction(portalScreenContext(PortalTelemetryScreen.PcsEventDialog), `${PortalTelemetryScreen.PcsEventDialog}.onClick.noButtonClick`, noButtonClick)}>No</Button>
                </>
            }

            {props.showYesNoButtons === false &&
                <>
                    <Button variant="contained" color="primary"
                        onClick={portalAction(portalScreenContext(PortalTelemetryScreen.PcsEventDialog), `${PortalTelemetryScreen.PcsEventDialog}.onClick.skipButtonClick`, skipButtonClick)} autoFocus>
                        Ok
                    </Button>
                </>
            }

            {props.showRedirectToPcsEventDashboard === true &&
                <>
                    <Button variant="contained" color="primary"
                        onClick={portalAction(portalScreenContext(PortalTelemetryScreen.PcsEventDialog), `${PortalTelemetryScreen.PcsEventDialog}.onClick.redirectToPcsEventDashboardClick`, redirectToPcsEventDashboardClick)} autoFocus>
                        Back to PCS events dashboard
                    </Button>
                </>
            }
        </DialogActions>
    </Dialog>
}